export enum NenaQueryParams {
  GEOMETRY = 'geometry',
  PLACE_ID = 'placeId',
}
